import './Differentials.css';
import content from '../data/content.json';

const Differentials: React.FC = () => {
  return (
    <section className="differentials" id="diferenciais">
      <div className="container">
        <h2>{content.differentials.title}</h2>

        <div className="differentials-list">
          {content.differentials.items.map((differential, index) => (
            <div key={index} className="differential-item">
              <span className="check-icon">✓</span>
              <p>{differential}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Differentials;
